import { Link } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';
import { mangaList } from '@/mocks/mangaData';

const slides = [
  {
    id: 'm2',
    title: '我独自升级',
    subtitle: '从最弱到最强 · 现象级热血漫画',
    description: '世界最弱猎人意外获得"升级系统"，踏上成为最强猎人的逆袭之路。震撼打斗与扣人心弦的剧情，全球阅读量突破140亿！',
    cta: '了解更多',
    link: '/article/a2',
    cover: mangaList[1].cover,
  },
  {
    id: 'm5',
    title: '甜蜜家园',
    subtitle: 'Netflix热门漫改 · 末日生存恐怖',
    description: '封闭公寓中的恐怖变异，人性欲望化为怪物。紧张氛围与深刻主题的完美结合，漫画与剧集双双封神。',
    cta: '了解更多',
    link: '/article/a3',
    cover: mangaList[4].cover,
  },
  {
    id: 'm10',
    title: '全知读者视角',
    subtitle: '末世穿越 · 读者拯救世界',
    description: '追了十年的小说变成现实，唯有他知道这个世界的一切结局。凭借对故事的理解，他踏上拯救世界的征程。',
    cta: '了解更多',
    link: '/article/a2',
    cover: mangaList[9].cover,
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((p) => (p - 1 + slides.length) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
            index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src={slide.cover}
              alt={slide.title}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        </div>
      ))}

      <div className="relative z-20 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-6 whitespace-nowrap">
            韩国漫画精选推荐
          </span>
          <h1 className="text-3xl md:text-5xl font-bold font-heading text-background-50 mb-3 leading-tight">
            {slides[current].title}
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-2 font-medium">
            {slides[current].subtitle}
          </p>
          <p className="text-sm md:text-base text-background-50/60 max-w-xl mx-auto mb-8 leading-relaxed">
            {slides[current].description}
          </p>
          <Link
            to={slides[current].link}
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {slides[current].cta}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-30 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 hover:bg-background-50/40 transition-all cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-30 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 hover:bg-background-50/40 transition-all cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
              index === current
                ? 'bg-primary-500 w-7'
                : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
          />
        ))}
      </div>
    </section>
  );
}